
import { PaperID } from '@/types/incitefulTypes'
import { defineComponent, PropType } from 'vue'

import SqlView from './SqlView.vue'
import Stat from './Stat.vue'
import { getOAPaper } from '@/utils/openalexApi'

export default defineComponent({
  name: 'PaperHeroStats',
  components: {
    SqlView,
    Stat
  },
  data() {
    return {
      oaLink: undefined as undefined | string,
      loading: true
    }
  },
  props: {
    numCitedBy: Number,
    numCiting: Number,
    publishedYear: Number,
    id: {} as PropType<PaperID>,
    doi: String,
    graphStats: { type: Boolean, default: false }
  },
  watch: {
    id: {
      handler(val: PaperID) {
        this.queryOA(val)
      }
    }
  },
  created(): void {
    if (this.id) {
      this.queryOA(this.id)
    }
  },
  methods: {
    queryOA(id: PaperID): void {
      if (id) {
        getOAPaper(id).then(data => {
          this.loading = false
          if (data && data.open_access.is_oa) {
            this.oaLink = data.open_access.oa_url
          }
        })
      } else {
        this.loading = false
      }
    }
  }
})
